import script from "./ChartBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartBox.vue?vue&type=script&setup=true&lang=js"

import "./ChartBox.vue?vue&type=style&index=0&id=b771a7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b771a7ae"]])

export default __exports__